export default {"src":"/_next/static/media/ic_select_bank.7054f4e7.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};